import { connect } from 'react-redux';
import { isLoading } from 'helpers';
import {
  loadMaTrainingsCreator,
  setMaTrainingsPageCreator,
  setMaTrainingsPerPageCreator,
  setMaTrainingsSortCreator,
  setMaTrainingsFiltersCreator,
  setMaTrainingsProfileCreator,
  removeMaTrainingCreator,
} from '../../../../store/actionsCreators';
import Trainings from '../../../../shared/Cpd/Trainings/Trainings';

const mapStateToProps = ({ loading, ma }) => ({
  loading: isLoading(loading, 'LOAD_MA_TRAININGS'),
  list: ma.trainings,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadMaTrainingsCreator()),
  setPage: (payload) => dispatch(setMaTrainingsPageCreator(payload)),
  setPerPage: (payload) => dispatch(setMaTrainingsPerPageCreator(payload)),
  setSort: (payload) => dispatch(setMaTrainingsSortCreator(payload)),
  setFilters: (payload) => dispatch(setMaTrainingsFiltersCreator(payload)),
  setProfile: (payload) => dispatch(setMaTrainingsProfileCreator(payload)),
  removeTraining: (payload) => dispatch(removeMaTrainingCreator(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Trainings);
